import { motion } from "framer-motion";
import { useSiteImages, pick } from "@/lib/siteImages";

const chapters = [
  {
    number: "01",
    title: "Fatto interamente a mano",
    description:
      "Niente produzioni in serie. Ogni medaglia viene tagliata, levigata e lucidata a mano nel nostro atelier, con la cura che merita un ricordo di famiglia.",
    image: "https://images.pexels.com/photos/7167015/pexels-photo-7167015.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    number: "02",
    title: "Incisioni con significato",
    description:
      "Il nome di tuo figlio, la sua data speciale, una parola che parla al tuo cuore. Incidiamo la tua storia nel metallo nobile, lettera dopo lettera.",
    image: "https://images.pexels.com/photos/7167000/pexels-photo-7167000.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    number: "03",
    title: "Materiali naturali ed etici",
    description:
      "Utilizziamo argento 925 e dorature ad alto spessore, pensati per durare nel tempo e rispettare la pelle dei più piccoli e delle loro mamme.",
    image: "https://images.pexels.com/photos/13292930/pexels-photo-13292930.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export default function Manifesto() {
  const siteImgs = useSiteImages();
  return (
    <section id="manifesto" className="py-28 lg:py-36 bg-[#37282B] relative overflow-hidden" data-testid="manifesto-section">
      <div className="absolute top-20 right-0 font-serif-display italic text-[16rem] leading-none text-[#FDF8F7]/[0.03] select-none pointer-events-none">
        Ma.Vi
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-20 max-w-2xl"
        >
          <span className="text-xs uppercase tracking-[0.3em] font-semibold text-[#E2A3B1]" data-testid="manifesto-overline">
            La nostra filosofia
          </span>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl mt-4 text-[#FDF8F7] leading-tight" data-testid="manifesto-headline">
            La passione per il dettaglio, <span className="italic text-[#E2A3B1]">l'amore per le famiglie</span>
          </h2>
        </motion.div>

        <div className="space-y-24 lg:space-y-32">
          {chapters.map((ch, i) => (
            <motion.div
              key={ch.number}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9 }}
              className={`grid lg:grid-cols-2 gap-10 lg:gap-20 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}
              data-testid={`manifesto-chapter-${ch.number}`}
            >
              <div className="relative">
                <span className="absolute -top-10 -left-2 font-serif-display italic text-8xl text-[#E2A3B1]/25 select-none">
                  {ch.number}
                </span>
                <div className="relative rounded-2xl overflow-hidden aspect-[4/3] shadow-2xl shadow-black/40 bg-[#FDF8F7]">
                  <img
                    src={pick(siteImgs, `manifesto_${i + 1}`, ch.image)}
                    alt={ch.title}
                    className="w-full h-full object-contain hover:scale-105 transition-transform duration-700"
                    data-testid={`manifesto-image-${ch.number}`}
                  />
                </div>
              </div>
              <div>
                <span className="font-serif-display italic text-xl text-[#E2A3B1]">Capitolo {ch.number}</span>
                <h3 className="font-serif-display text-3xl sm:text-4xl text-[#FDF8F7] mt-3" data-testid={`manifesto-title-${ch.number}`}>
                  {ch.title}
                </h3>
                <p className="mt-5 text-base sm:text-lg text-[#FDF8F7]/70 leading-relaxed max-w-md">
                  {ch.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
